<h1 class="page-title mb-5">الأداء الاقتصادي</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <section class="mb-5">
          <h3 class="text-success fw-bold mb-3">
            الإدارة المركزية لتقييم الحصص العينية والمتابعة
          </h3>
          <p class="mb-3">
            تقدم الإدارة المركزية لتقييم الحصص العينية والمتابعة مجموعه من خدمات
            الفحص المالي المسبق بغرض تعديل الهياكل المالية لشركات الأموال وهي:
          </p>
          <ul class="list-unstyled mb-4">
            <li class="mb-2">
              -فحص ودراسة (الارباح – الاحتياطيات – الأرصدة الدائنة المستحقة
              للمساهمين) بغرض استخدمها فى تمويل زيادة أو استكمال رأس المال .
            </li>
            <li class="mb-2">
              -فحص الشركات بغرض التحقق من سلامة الهيكل التمويلي لها بما يسمح
              بتخفيض رأس المال.
            </li>
            <li class="mb-2">
              -فحص راس المال للشركات للتحقق من المقدار المسدد فعليا بغرض احتساب
              الوزن النسبي عند استصدار الاقامات للمستثمرين الأجانب.
            </li>
          </ul>

          <p class="mb-3">
            كما ان الإدارة المركزية هي المسئولة عن الأمانة الفنية للجان التقييم,
            فان القطاع ممثلاً من خلال العاملين به فى تشكيل تلك اللجان, وبيان
            انواع الطلبات التي تحال الى تلك اللجان كالتالي:
          </p>
          <p class="fw-bold mb-2">
            التحقق من صحة التقدير المبدئي لصافى أصول والتزامات الشركات بغرض:
          </p>
          <ul class="list-unstyled mb-4">
            <li>-الاندماج</li>
            <li>-الانقسام</li>
            <li>
              -الحصص العينية للمساهمة في راس مال شركة مساهمة (قائمة او تحت
              التأسيس)
            </li>
          </ul>
        </section>

        <section class="mb-5">
          <h3 class="text-success fw-bold mb-3 d-flex align-items-center">
            <span class="ms-2">•</span> فحص الهياكل المالية:
          </h3>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-center fw-bold" style="width: 50%">
                    النماذج الاسترشادية
                  </th>
                  <th class="text-center fw-bold" style="width: 50%">
                    المستندات المطلوبة
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a href="assets/نموذج طلب زيادة رأس المال من الارباح والاحتياطيات والارصدة الدائنة.pdf"
                      target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      نموذج طلب زيادة رأس المال من الارباح والاحتياطيات والارصدة
                      الدائنة
                    </a>
                  </td>
                  <td>
                    <a href="assets/زيادة أو استكمال من الارباح.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      زيادة أو استكمال من الارباح
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/نموذج بيان توزيعات الارباح منذ نشأة رصيد الارباح.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      نموذج بيان توزيعات الارباح منذ نشأة رصيد الارباح
                    </a>
                  </td>
                  <td>
                    <a href="assets/زيادة أو استكمال من الرصيد الدائن.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      زيادة أو استكمال من الرصيد الدائن
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/اقرار بالأرصدة المدينة والدائنة الخاصة بالمساهمين.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      اقرار بالأرصدة المدينة والدائنة الخاصة بالمساهمين
                    </a>
                  </td>
                  <td>
                    <a href="assets/تغيير مسمي رأس المال من اجنبي لمصري.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      تغيير مسمي رأس المال من اجنبي لمصري
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/بيان بإجمالي الأجور السنوية للعاملين.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      بيان بإجمالي الأجور السنوية للعاملين
                    </a>
                  </td>
                  <td>
                    <!-- Placeholder for the missing PDF or duplication if needed, sticking to image text -->
                    <span class="text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      تغيير مسمي رأس المال من مصري لأجنبي
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/دليل الارصدة الدائنة - 2025.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      دليل الارصدة الدائنة - 2025
                    </a>
                  </td>
                  <td>
                    <a href="assets/فحص الموقف المالى للشركة.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      فحص الموقف المالى للشركة
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section class="mb-5">
          <h3 class="text-success fw-bold mb-3 d-flex align-items-center">
            <span class="ms-2">•</span> التقييم بأنواعه:
          </h3>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-center fw-bold" style="width: 50%">
                    النماذج الاسترشادية
                  </th>
                  <th class="text-center fw-bold" style="width: 50%">
                    المستندات المطلوبة
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a href="assets/نموذج طلب بغرض تقييم حصة عينية.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      نموذج طلب بغرض تقييم حصة عينية
                    </a>
                  </td>
                  <td>
                    <a href="assets/تاسيس أو زيادة شركة بحصة عينية.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      تاسيس أو زيادة شركة بحصة عينية
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/نموذج طلب بغرض تغيير الشكل القانوني.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      نموذج طلب بغرض تغيير الشكل القانوني
                    </a>
                  </td>
                  <td>
                    <a href="assets/تقييم لتغيير الشكل القانوني.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      تقييم لتغيير الشكل القانوني
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/نموذج طلب بغرض الاندماج.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      نموذج طلب بغرض الاندماج
                    </a>
                  </td>
                  <td>
                    <a href="assets/تقييم بغرض الاندماج.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      تقييم بغرض الاندماج
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/نموذج طلب بغرض الانقسام.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      نموذج طلب بغرض الانقسام
                    </a>
                  </td>
                  <td>
                    <a href="assets/تقييم بغرض الانقسام.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      تقييم بغرض الانقسام
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="assets/دليل قواعد التقييم اصدار ديسمبر 2025.pdf" target="_blank"
                      class="text-decoration-none text-dark d-flex align-items-center justify-content-start">
                      <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
                      دليل قواعد التقييم اصدار ديسمبر 2025
                    </a>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section class="mb-5">
          <h3 class="text-success fw-bold mb-3 d-flex align-items-center">
            <span class="ms-2">•</span> الأسئلة الشائعة الخاصة بالخدمات التي
            يقدمها قطاع الأداء الاقتصادي:
          </h3>
          <div class="mb-4 text-end">
            <a href="assets/أسئلة شائعة.pdf" target="_blank"
              class="text-decoration-none text-dark fw-bold d-inline-flex align-items-center">
              <fa-icon [icon]="faFilePdf" class="text-danger me-2"></fa-icon>
              أسئلة شائعة
            </a>
          </div>

          <h3 class="text-success fw-bold mb-3 d-flex align-items-center">
            <span class="ms-2">•</span> وسائل التواصل:
          </h3>
          <ul class="list-unstyled contact-info">
            <li class="mb-2 d-flex justify-content-start align-items-center flex-wrap">
              <span class="ms-2">تليفون:</span>
              <span dir="ltr">+202-267 36 900</span>
              <span class="mx-2">داخلي:</span>
              <span>2030 / 2009 / 2010</span>
            </li>
            <li class="mb-2 d-flex justify-content-start align-items-center flex-wrap">
              <span class="ms-2">البريد الالكتروني:</span>
              <span class="me-3">eps_evaluation&#64;gafinet.org.eg</span>
              <span>eps_capitaledit&#64;gafinet.org.eg</span>
            </li>
            <li class="mb-2 d-flex justify-content-start align-items-center flex-wrap">
              <span class="ms-2 fw-bold text-dark">تلجرام:</span>
              <a href="https://t.me/joinchat/cxzKGk045wJjNGJk" target="_blank" class="text-decoration-none"
                style="color: #6f42c1">الإستفسار عبر التيليجرام</a>
            </li>
          </ul>
        </section>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>